import { render, staticRenderFns } from "./SecondaryButton.vue?vue&type=template&id=3ad4d84a&"
import script from "./SecondaryButton.vue?vue&type=script&lang=js&"
export * from "./SecondaryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports